/**
 * Fertige `handle`-Werte zum Anhängen an eine Route.
 *
 * Eigene Datei neben der Komponente, damit `SectionCrumb.tsx` nur eine
 * Komponente ausführt — sonst fällt Fast Refresh für die Datei aus.
 */

import { SectionCrumb } from './SectionCrumb';
import type { RouteHandle } from './route-handle';

/** Ein Bereich der Hauptnavigation: `handle={SECTION_CRUMB}`. */
export const SECTION_CRUMB: RouteHandle = { crumb: SectionCrumb };
